import type { IDescriptor } from "../descriptor";
import type { IFileLink } from "../file";
import { isOfType } from "../utils";

export interface CSVData {
  type: "csv_data_source";
  file_link: IFileLink;
  column_definitions: Partial<Record<string, IDescriptor>>;
}

export interface ExperimentsDataSource {
  type: "experiments_data_source";
  id: string;
}

export interface SnapshotDataSource {
  type: "snapshot_data_source";
  snapshot_id: string;
}

export interface TableData {
  type: "hosted_table_data_source";
  table_id: string;
  table_version: number;
}

export type TrainingData =
  | CSVData
  | TableData
  | ExperimentsDataSource
  | SnapshotDataSource;

export type CSVDataSourceID = `csv::${string}::${string}`;
export type ExperimentDataSourceID = `experiments::${string}`;
export type GEMDDataSourceID = `gemd::${string}::${number}`;
export type SnapshotDataSourceID = `snapshot::${string}`;
export type DataSourceID =
  | CSVDataSourceID
  | ExperimentDataSourceID
  | GEMDDataSourceID
  | SnapshotDataSourceID;

export const isCSVData = isOfType<CSVData, TrainingData>("csv_data_source");
export const isTableData = isOfType<TableData, TrainingData>(
  "hosted_table_data_source",
);
export const isExperimentData = isOfType<ExperimentsDataSource, TrainingData>(
  "experiments_data_source",
);
export const isSnapshot = isOfType<SnapshotDataSource, TrainingData>(
  "snapshot_data_source",
);
